export const multiplicarDecimales = (numero1, numero2) => {
    return parseFloat(parseFloat(numero1) * parseFloat(numero2));
};